export default {
  title: "Service Logs",
  button_add: "Add status",
  title_form: "Add Status",
  placeholder_input: "Choose from the list",
  subtitle_form: "Apply the date for the status:",
  text_today: "Today",
};
